import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { MEMBERS_PERMISSION } from "./-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/members",
)({
  staticData: {
    breadcrumb: [
      { label: "Workspace - Members", href: "/settings/workspace/members" },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      MEMBERS_PERMISSION,
      "/settings/workspace/general",
    ),
})
